module.exports = __webpack_public_path__ + "img/iu_logo_mark.117d35af.jpg";